"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUpdatedFilters = exports.removeFilter = exports.addFilter = exports.getAllSections = void 0;
/* eslint-disable default-param-last */
/* eslint-disable arrow-body-style */
var filterBar_model_1 = require("../models/filterBar.model");
var getAllSections = function (categories) {
    var allSections = [];
    if (categories) {
        categories.forEach(function (category) {
            allSections.push.apply(allSections, category.sections);
        });
    }
    return allSections;
};
exports.getAllSections = getAllSections;
var addFilter = function (filterBar, sectionId, value) {
    var _a, _b;
    if (filterBar === void 0) { filterBar = {}; }
    return filterBar[sectionId]
        ? __assign(__assign({}, filterBar), (_a = {}, _a[sectionId] = filterBar[sectionId].includes(value)
            ? __spreadArray([], filterBar[sectionId], true) : __spreadArray(__spreadArray([], filterBar[sectionId], true), [value], false), _a)) : __assign(__assign({}, filterBar), (_b = {}, _b[sectionId] = [value], _b));
};
exports.addFilter = addFilter;
var removeFilter = function (filterBar, sectionId, value) { return (filterBar[sectionId].includes(value)
    ? __spreadArray(__spreadArray([], filterBar[sectionId].slice(0, filterBar[sectionId].indexOf(value)), true), filterBar[sectionId].slice(filterBar[sectionId].indexOf(value) + 1, filterBar[sectionId].length), true) : filterBar[sectionId]); };
exports.removeFilter = removeFilter;
var getUpdatedFilters = function (categories, filterId, currentFilters) {
    var newFilters = (0, filterBar_model_1.filterBarStateFactory)({ filterId: filterId, sections: (0, exports.getAllSections)(categories) });
    var updatedFilters = {};
    Object.keys(newFilters[filterId]).forEach(function (key) {
        var _a;
        Object.assign(updatedFilters, (_a = {}, _a[key] = __spreadArray([], newFilters[filterId][key], true), _a));
    });
    if (currentFilters) {
        Object.keys(currentFilters).forEach(function (key) {
            var _a;
            Object.assign(updatedFilters, (_a = {}, _a[key] = __spreadArray([], currentFilters[key], true), _a));
        });
    }
    return updatedFilters;
};
exports.getUpdatedFilters = getUpdatedFilters;
